export const END_OF_STAY_SECTION_LABELS = {
    aloa: 'Aloa',
    lacdesgraves: 'Lac des Graves',
    flower: 'Flower / Trips',
};

export const END_OF_STAY_ACTION_CONFIG = {
    recap_guarantee_not_triggered: {
        text: 'Récap — garantie non déclenchée',
        variant: 'success',
    },
    no_trigger_observation_recap: {
        text: 'Récap observation non déclenchée',
        variant: 'success',
    },
    promise_summary_and_rib_request: {
        text: 'Récap sinistres + demande RIB',
        variant: 'warning',
    },
    skipped_cancelled_policy: {
        text: 'Police annulée — ignorée',
        variant: 'secondary',
    },
};

export const getEndOfStayActionConfig = (action) => (
    END_OF_STAY_ACTION_CONFIG[action] || {
        text: action || '—',
        variant: 'secondary',
    }
);

/**
 * Ex. cron "40 10 * * *" → "10h40"
 */
export const formatScheduledTime = (section) => {
    if (!section) return '—';

    const cron = section.scheduled_cron;
    if (cron && typeof cron === 'string') {
        const parts = cron.trim().split(/\s+/);
        if (parts.length >= 2) {
            const minute = parts[0];
            const hour = parts[1];
            if (/^\d+$/.test(minute) && /^\d+$/.test(hour)) {
                return `${hour}h${minute.padStart(2, '0')}`;
            }
        }
    }

    if (section.scheduled_hour_paris !== null && section.scheduled_hour_paris !== undefined) {
        return `${section.scheduled_hour_paris}h00`;
    }

    return '—';
};
